const moneyFormatter = (amount) => {
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP'
  }).format(amount)
}

const cleanStringToFilter = (str) => {
  // Eliminar acentos
  str = str.normalize('NFD').replace(/\p{Diacritic}/gu, '')
  // Convertir a minúsculas
  str = str.toLowerCase()
  // Eliminar caracteres especiales
  str = str.replace(/[^a-zA-Z0-9]/g, '')
  // Eliminar espacios en blanco
  str = str.replace(/\s+/g, '')
  return str
}

export default {
  moneyFormatter,
  cleanStringToFilter
}
